import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initAiFetchTracker } from './utils/aiFetchTracker';

initAiFetchTracker();

const isProduction = process.env.NODE_ENV === 'production';
const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
const fromLogin = new URLSearchParams(window.location.search).get('fromLogin') === '1';
const page = pathname === '/discover' ? 'discover' : pathname === '/mentions-legales' ? 'legal' : pathname === '/conditions-utilisation' ? 'terms' : 'app';

// En production, /discover n'est accessible que depuis le lien du login.
if (page === 'discover' && isProduction && !fromLogin) {
  window.location.replace('/');
}

// Chargement paresseux : les pages statiques ne chargent pas le métavers, et inversement.
const DiscoverPage = React.lazy(() => import('./discover/DiscoverPage'));
const LegalPage = React.lazy(() => import('./components/LegalPage'));
const AppWithProviders = React.lazy(() =>
  Promise.all([import('./App'), import('./components/ConfirmModal')]).then(
    ([{ default: App }, { ModalProvider }]) => ({
      default: () => (
        <ModalProvider>
          <App />
        </ModalProvider>
      ),
    })
  )
);

function Router() {
  if (page === 'discover') return <DiscoverPage />;
  if (page === 'legal') return <LegalPage page="legal" />;
  if (page === 'terms') return <LegalPage page="terms" />;
  return <AppWithProviders />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<div style={{ background: '#050713', width: '100%', height: '100vh' }} />}>
      <Router />
    </Suspense>
  </React.StrictMode>
);
